import React, { FC } from "react";
import { Box } from "@mui/material";
import ReactMarkdown from "react-markdown";
import { Components } from "react-markdown/src/ast-to-react";
import TrackedLink from "./tracked-link";
const remarkGfm = require("remark-gfm");
const rehypeRaw = require("rehype-raw");

interface MarkdownViewerProps {
  content: string;
}

const markdownComponents: Components = { a: TrackedLink };

const MarkdownViewer: React.FC<MarkdownViewerProps> = ({ content }) => {
  return (
    <Container>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={markdownComponents}
      >
        {content}
      </ReactMarkdown>
    </Container>
  );
};

export default MarkdownViewer;

const Container: FC = ({ children }) => {
  return (
    <Box
      sx={{
        "& p, & li": {
          fontSize: { xs: "14px", sm: "16px" },
          lineHeight: { xs: "20px", sm: "24px" },
          margin: 0,
        },
        "& strong, & em": {
          fontSize: { xs: "14px", sm: "16px" },
        },
      }}
    >
      {children}
    </Box>
  );
};
